import React from "react";
import FormSelect from "../../../components/UI/formSelect/formSelect";
import Input from "../../../components/UI/input/GgInput";
import { AddIcon } from "../../../assets/icons";
import FileButton from "../../../components/UI/button/FileButton";
import { IContent, IPMBlock } from "../../../models/IPages";
import { getImageExtensionFromBase64 } from "../../../utils";

function GuideBlock({ data, setData, articles, categoryType, title, actionData }: IPMBlock) {
  const handleGuideBlock = (val: string, type: keyof IContent) =>
    setData((prev: any) => {
      if (type === "image") {
        const ext = getImageExtensionFromBase64(val);
        return {
          ...prev,
          [type]: `/image/page-management/${categoryType}/guideBlock1.${ext || "jpeg"
            }`,
          images: [val],
        };
      }
      return { ...prev, [type]: val };
    });
  return (
    <>
      <div className="title">{title || "Guide Block"}</div>
      <div className="step-list">
        <div className="step-item">
          <FileButton
            index={"refinance-guide"}
            icon={{
              leftIcon: <AddIcon size="18" className="icon" />,
            }}
            value={data?.image}
            stylesType="border"
            onChange={(val) => handleGuideBlock(val, "image")}
            className="cover-image-button"
            disabled={!actionData?.edit}
          />
        </div>
        <div className="step-list col">
          <div className="step-item">
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter title"
                value={data?.heading}
                onChange={(val) => handleGuideBlock(val, "heading")}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter Description"
                value={data?.description}
                onChange={(val) => handleGuideBlock(val, "description")}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <Input
              type="text"
              placeholder="Enter link"
              value={data?.link}
              onChange={(val) => handleGuideBlock(val, "link")}
              disabled={!actionData?.edit}
            />
            {/* <FormSelect
              list={articles}
              defaultValue={data?.link}
              label="Page link"
              onChange={(val) => handleGuideBlock(val.value, "link")}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default GuideBlock;
